import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, " Select Dependent Relationship ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "w-100 pdt-15" }, " Add Dependent Information ", -1)
const _hoisted_3 = { class: "w-100 d-flex gap-20 align-items-end flex-md-row flex-column" }
const _hoisted_4 = {
  key: 0,
  class: "w-100 d-flex gap-20 align-items-end flex-md-row flex-column"
}
const _hoisted_5 = {
  key: 1,
  class: "w-100 d-flex gap-20 align-items-end flex-md-row flex-column"
}
const _hoisted_6 = { class: "w-100 d-flex gap-10 align-items-end" }
const _hoisted_7 = { class: "w-100 d-flex gap-4 flex-md-row flex-column" }
const _hoisted_8 = {
  key: 4,
  class: "radio-group bold highlight w-sm-100"
}
const _hoisted_9 = { class: "radio-buttons w-50 w-sm-100" }
const _hoisted_10 = ["id", "value", "disabled"]
const _hoisted_11 = ["for"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "w-50" }, " Address ", -1)
const _hoisted_13 = { class: "form w-100" }
const _hoisted_14 = { class: "action-buttons sm-pdl-0 sm-pdr-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_DateInput = _resolveComponent("DateInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_SelectComponent, {
      customClass: "full-width pdt-5 h-auto",
      selectedOption: _ctx.dependentStore.Person.Relationship,
      "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dependentStore.Person.Relationship) = $event)),
      options: _ctx.dependentStore.relationships,
      "single-arrow": true,
      readonly: _ctx.isEditAction,
      error: _ctx.errors.Relationship,
      hasDefaultOption: false,
      "is-required": true
    }, null, 8, ["selectedOption", "options", "readonly", "error"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SelectComponent, {
        label: "Country",
        selectedOption: _ctx.dependentStore.Person.CitizenshipCode,
        "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dependentStore.Person.CitizenshipCode) = $event)),
        options: _ctx.dependentStore.countries,
        "single-arrow": true,
        readonly: _ctx.isEditAction
      }, null, 8, ["selectedOption", "options", "readonly"]),
      (!_ctx.isEditAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_TextInput, {
              type: "text",
              name: _ctx.ssnType,
              label: _ctx.ssnLabel,
              placeholder: _ctx.ssnPlaceholder,
              max: _ctx.ssnMaxLength,
              readonly: _ctx.isEditAction,
              modelValue: _ctx.dependentStore.Person.SSN,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dependentStore.Person.SSN) = $event)),
              required: true,
              error: _ctx.errors.SSN,
              "is-required": _ctx.dependentStore.Person.Relationship?.key == '181' || (_ctx.dependentStore.Person.Relationship?.key == '162' && !_ctx.dependentStore.Person.NoSSN)
            }, null, 8, ["name", "label", "placeholder", "max", "readonly", "modelValue", "error", "is-required"]),
            (_ctx.isNoSSNVisible)
              ? (_openBlock(), _createBlock(_component_CheckBox, {
                  key: 0,
                  readonly: _ctx.isEditAction,
                  label: "Please check the box if you have not yet acquired a SSN for this Dependent.",
                  className: "ssn-checkbox fs-sm sm-fs-xxs",
                  id: "ssn",
                  onChange: _ctx.handleChildSSN,
                  modelValue: _ctx.dependentStore.Person.NoSSN,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dependentStore.Person.NoSSN) = $event)),
                  showLabel: true
                }, null, 8, ["readonly", "onChange", "modelValue"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_TextInput, {
                type: "text",
                customClass: "w-full",
                name: _ctx.ssnType,
                label: _ctx.ssnLabel,
                placeholder: _ctx.ssnPlaceholder,
                max: _ctx.ssnMaxLength,
                readonly: _ctx.isEditAction,
                modelValue: _ctx.dependentStore.Person.SSN,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dependentStore.Person.SSN) = $event)),
                required: true,
                error: _ctx.errors.SSN,
                "is-required": _ctx.dependentStore.Person.Relationship?.key == '181' || (_ctx.dependentStore.Person.Relationship?.key == '162' && !_ctx.dependentStore.Person.NoSSN)
              }, null, 8, ["name", "label", "placeholder", "max", "readonly", "modelValue", "error", "is-required"]),
              (_ctx.dependentStore.Person.SSN)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "plan-modal text-underline text-primary w-100 mb-10",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openModal('recaptcha', 'Show SSN', 'modal-success', null, {entity: _ctx.dependentStore.Person?.PersonID, Type: _ctx.dependentStore.Person.Relationship?.value })), ["prevent"]))
                  }, "Show SSN"))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isNoSSNVisible)
              ? (_openBlock(), _createBlock(_component_CheckBox, {
                  key: 0,
                  readonly: _ctx.isEditAction,
                  label: "Please check the box if you have not yet acquired a SSN for this Dependent.",
                  className: "ssn-checkbox fs-sm sm-fs-xxs",
                  id: "ssn",
                  onChange: _ctx.handleChildSSN,
                  modelValue: _ctx.dependentStore.Person.NoSSN,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dependentStore.Person.NoSSN) = $event)),
                  showLabel: true
                }, null, 8, ["readonly", "onChange", "modelValue"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_SelectComponent, {
        label: "Salutation",
        selectedOption: _ctx.dependentStore.Person.Salutation,
        "onUpdate:selectedOption": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dependentStore.Person.Salutation) = $event)),
        options: _ctx.dependentStore.salutations,
        "single-arrow": true,
        hasDefaultOption: true,
        readonly: _ctx.isEditAction
      }, null, 8, ["selectedOption", "options", "readonly"]),
      _createVNode(_component_TextInput, {
        type: "text",
        label: "First Name",
        placeholder: "Enter First Name",
        max: 12,
        modelValue: _ctx.dependentStore.Person.FirstName,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dependentStore.Person.FirstName) = $event)),
        readonly: _ctx.isEditAction,
        required: true,
        error: _ctx.errors.FirstName,
        "is-required": true
      }, null, 8, ["modelValue", "readonly", "error"]),
      _createVNode(_component_TextInput, {
        type: "text",
        label: "Middle Name",
        placeholder: "Enter Middle Name",
        max: 12,
        modelValue: _ctx.dependentStore.Person.MiddleName,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dependentStore.Person.MiddleName) = $event)),
        readonly: _ctx.isEditAction,
        error: _ctx.errors.MiddleName
      }, null, 8, ["modelValue", "readonly", "error"]),
      _createVNode(_component_TextInput, {
        type: "text",
        label: "Last Name",
        placeholder: "Enter Last Name",
        max: 25,
        modelValue: _ctx.dependentStore.Person.LastName,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dependentStore.Person.LastName) = $event)),
        readonly: _ctx.isEditAction,
        error: _ctx.errors.LastName,
        "is-required": true
      }, null, 8, ["modelValue", "readonly", "error"]),
      _createVNode(_component_SelectComponent, {
        label: "Suffix",
        selectedOption: _ctx.dependentStore.Person.NameSuffix,
        "onUpdate:selectedOption": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dependentStore.Person.NameSuffix) = $event)),
        options: _ctx.dependentStore.nameSuffixes,
        "single-arrow": true,
        hasDefaultOption: true,
        readonly: _ctx.isEditAction
      }, null, 8, ["selectedOption", "options", "readonly"])
    ]),
    _createVNode(_component_DateInput, {
      label: "Date of Birth",
      modelValue: _ctx.dependentStore.Person.DateofBirth,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dependentStore.Person.DateofBirth) = $event)),
      placeholder: _ctx.isEditAction ? 'dd/mm/yyyy' : '',
      "input-type": "date",
      readonly: _ctx.isEditAction,
      error: _ctx.errors.DateofBirth,
      "is-required": true,
      futureAllow: false
    }, null, 8, ["modelValue", "placeholder", "readonly", "error"]),
    _createVNode(_component_SelectComponent, {
      label: "Gender",
      selectedOption: _ctx.dependentStore.Person.Sex,
      "onUpdate:selectedOption": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dependentStore.Person.Sex) = $event)),
      options: _ctx.dependentStore.genders,
      "single-arrow": true,
      readonly: _ctx.isEditAction
    }, null, 8, ["selectedOption", "options", "readonly"]),
    (_ctx.isMaritalStatusVisible)
      ? (_openBlock(), _createBlock(_component_SelectComponent, {
          key: 0,
          label: "Marital Status",
          selectedOption: _ctx.dependentStore.Person.MaritalStatus,
          "onUpdate:selectedOption": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dependentStore.Person.MaritalStatus) = $event)),
          options: _ctx.dependentStore.maritalStatuses,
          "single-arrow": true,
          error: _ctx.errors.MaritalStatus,
          "is-required": true,
          readonly: _ctx.isEditAction
        }, null, 8, ["selectedOption", "options", "error", "readonly"]))
      : _createCommentVNode("", true),
    (_ctx.isMarriageDateVisible)
      ? (_openBlock(), _createBlock(_component_DateInput, {
          key: 1,
          label: "Date of Marriage",
          modelValue: _ctx.dependentStore.Person.MarriageDate,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dependentStore.Person.MarriageDate) = $event)),
          placeholder: _ctx.isEditAction ? 'dd/mm/yyyy' : '',
          "input-type": "date",
          readonly: _ctx.isEditAction,
          error: _ctx.errors.MarriageDate,
          "is-required": true,
          futureAllow: false
        }, null, 8, ["modelValue", "placeholder", "readonly", "error"]))
      : _createCommentVNode("", true),
    (_ctx.isDivorceDateVisible)
      ? (_openBlock(), _createBlock(_component_DateInput, {
          key: 2,
          label: "Divorce/Affidavit Date",
          modelValue: _ctx.dependentStore.Person.DivorceDate,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dependentStore.Person.DivorceDate) = $event)),
          placeholder: _ctx.isEditAction ? 'dd/mm/yyyy' : '',
          "input-type": "date",
          readonly: _ctx.isEditAction,
          error: _ctx.errors.DivorceDate,
          "is-required": true,
          futureAllow: false
        }, null, 8, ["modelValue", "placeholder", "readonly", "error"]))
      : _createCommentVNode("", true),
    (_ctx.isDateofDeathVisible)
      ? (_openBlock(), _createBlock(_component_DateInput, {
          key: 3,
          label: "Date of Death/Affidavit Date",
          modelValue: _ctx.dependentStore.Person.DateofDeath,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dependentStore.Person.DateofDeath) = $event)),
          placeholder: _ctx.isEditAction ? 'dd/mm/yyyy' : '',
          "input-type": "date",
          readonly: _ctx.isEditAction,
          error: _ctx.errors.DateofDeath,
          "is-required": true,
          futureAllow: false
        }, null, 8, ["modelValue", "placeholder", "readonly", "error"]))
      : _createCommentVNode("", true),
    (!_ctx.isEditAction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{'highlight bg-light-green': _ctx.dependentStore.CreateAddressType == option.value, 'disabled bg-dark-grey': _ctx.isEditAction}, "radio-button bordered-card bordered-card_secondary pdt-20 pdb-20 align-items-start"])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: `PaymentOption${index + 1}`,
                  name: "PaymentOption",
                  value: option.value,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dependentStore.CreateAddressType) = $event)),
                  disabled: _ctx.isEditAction
                }, null, 8, _hoisted_10), [
                  [_vModelRadio, _ctx.dependentStore.CreateAddressType]
                ]),
                _createElementVNode("label", {
                  class: "body-text",
                  for: `PaymentOption${index + 1}`
                }, _toDisplayString(option.label), 9, _hoisted_11)
              ], 2))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    ((_ctx.isEditAction && _ctx.dependentStore.Address?.Type.key) || (!_ctx.isEditAction && _ctx.dependentStore.CreateAddressType))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_SelectComponent, {
              label: "Address Type",
              selectedOption: _ctx.dependentStore.Address.Type,
              "onUpdate:selectedOption": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dependentStore.Address.Type) = $event)),
              options: _ctx.profileStore.addressTypes,
              "single-arrow": true,
              hasDefaultOption: true,
              error: _ctx.errors.Type,
              "is-required": true,
              readonly: _ctx.isEditAction
            }, null, 8, ["selectedOption", "options", "error", "readonly"]),
            _createVNode(_component_TextInput, {
              type: "text",
              name: "mixed",
              label: "Address",
              placeholder: "Enter Address 1",
              max: 30,
              modelValue: _ctx.dependentStore.Address.Street1,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dependentStore.Address.Street1) = $event)),
              required: true,
              error: _ctx.errors.Street1,
              "is-required": true,
              readonly: _ctx.isEditAction
            }, null, 8, ["modelValue", "error", "readonly"]),
            _createVNode(_component_TextInput, {
              type: "text",
              name: "mixed",
              placeholder: "Enter City",
              label: ['US', 'CA', 'MX'].includes(_ctx.dependentStore.Address.Country?.key) ? 'City' : 'City/State',
              max: 25,
              modelValue: _ctx.dependentStore.Address.City,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dependentStore.Address.City) = $event)),
              required: true,
              error: _ctx.errors.City,
              isRequired: true,
              readonly: _ctx.isEditAction
            }, null, 8, ["label", "modelValue", "error", "readonly"]),
            _createVNode(_component_SelectComponent, {
              label: "State",
              selectedOption: _ctx.dependentStore.Address.State,
              "onUpdate:selectedOption": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.dependentStore.Address.State) = $event)),
              options: _ctx.filteredStates,
              error: _ctx.errors?.State,
              isRequired: ['US', 'CA', 'MX'].includes(_ctx.dependentStore.Address.Country?.key) && !_ctx.isEditAction,
              readonly: !['US', 'CA', 'MX'].includes(_ctx.dependentStore.Address.Country?.key) || _ctx.isEditAction
            }, null, 8, ["selectedOption", "options", "error", "isRequired", "readonly"]),
            _createVNode(_component_SelectComponent, {
              label: "Country",
              selectedOption: _ctx.dependentStore.Address.Country,
              "onUpdate:selectedOption": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dependentStore.Address.Country) = $event)),
              options: _ctx.profileStore.countries,
              "single-arrow": true,
              readonly: _ctx.isEditAction
            }, null, 8, ["selectedOption", "options", "readonly"]),
            _createVNode(_component_TextInput, {
              type: "text",
              name: "number",
              label: "ZIP code",
              placeholder: "Enter ZIP code",
              max: 9,
              error: _ctx.errors.Zip,
              modelValue: _ctx.dependentStore.Address.Zip,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dependentStore.Address.Zip) = $event)),
              required: true,
              "is-required": true,
              readonly: _ctx.isEditAction
            }, null, 8, ["error", "modelValue", "readonly"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_TextInput, {
      type: "email",
      label: "Email",
      placeholder: "Enter Email here",
      max: 50,
      modelValue: _ctx.dependentStore.Email,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.dependentStore.Email) = $event)),
      required: true,
      readonly: _ctx.isEditAction
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(_component_TextInput, {
      type: "tel",
      name: "phone",
      label: "Phone no",
      placeholder: "Enter Phone Number here",
      max: 50,
      modelValue: _ctx.dependentStore.PhoneNumber,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.dependentStore.PhoneNumber) = $event)),
      required: true,
      readonly: _ctx.isEditAction
    }, null, 8, ["modelValue", "readonly"]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("a", {
        href: "",
        onClick: _cache[27] || (_cache[27] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"])),
        class: "btn btn-secondary"
      }, "Back"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.handleStep2 && _ctx.handleStep2(...args)))
      }, " Step 2 ")
    ])
  ], 64))
}